

   import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { WelfaretypeDTO } from './welfaretype.dto';


export class WelfaretypeResponseModel extends GlobalResponseObject {
  data?: WelfaretypeDTO;
  response:WelfaretypeDTO[];
}

export class AllWelfaretypeResponseModel extends GlobalResponseObject {
    data?: WelfaretypeDTO[];
    response:WelfaretypeDTO[];
  }